export default __webpack_public_path__ + "static/media/icon-search.20aa9b7e.svg";